import React from "react";
import STOCKHoldingsTable from "../../components/HoldingsTable/STOCKHoldingsTable";
import HoldingsErrorDialog from "../../components/HoldingsTable/HoldingsErrorDialog";
import AppLoader from "../../components/AppLoader/AppLoader";
import { useUserHoldingsFetch } from "./useUserHoldingsFetch";

interface STOCK {
  id: number;
  symbol: string;
  createdAt: string;
  units: number;
  purchasePrice: number;
  amount: number;
  currentAmount: number;
  currentPrice: number;
  gainLoss: number;
  gainLossPerc: number;
}

const STOCKHoldings: React.FC = () => {
  const {
    loader,
    errorMessage,
    setErrorMessage,
    data: STOCK,
    pageSize,
    totalPages,
    currentPage,
    handlePageChange,
    handlePageSizeChange,
    fetchHoldings,
  } = useUserHoldingsFetch<STOCK>("STOCK", "Failed to load equity holdings.");

  return (
    <>
      <AppLoader loading={loader} />
      <STOCKHoldingsTable
        data={STOCK}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        fetchData={fetchHoldings}
      />
      <HoldingsErrorDialog
        open={Boolean(errorMessage)}
        message={errorMessage}
        title="Unable to load equity holdings"
        onClose={() => setErrorMessage(null)}
      />
    </>
  );
};

export default STOCKHoldings;
